/**
 * Emoji Manager
 * Handles random emoji generation for the footer
 */

declare global {
    interface Window {
        emojiManager?: EmojiManager;
    }
}

export class EmojiManager {
    emojis: string[];

    constructor() {
        this.emojis = ['❤️', '🔥', '⭐', '🎉', '🚀', '🎲', '☕', '🌶️', '🌈', '🍭', '🧁', '💪', '👾', '🏀', '👀', '🦴', '🧨'];
        this.initialize();
    }

    initialize(): void {
        window.addEventListener('load', () => this.setRandomEmoji());
    }

    setRandomEmoji(): void {
        const randomIndex = Math.floor(Math.random() * this.emojis.length);
        const emojiElement = document.getElementById('randomEmoji');
        if (emojiElement) {
            emojiElement.textContent = this.emojis[randomIndex];
        }
    }
}

// Initialize the emoji manager
window.emojiManager = new EmojiManager();
